import { defer, LoaderFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isDefined, isNotDefined, isTokenExpired, retrieveToken } from '@hsp/utilities';

import { createBuildShopQuery } from '@p/audience/shared/hooks/queries/shop/fetch-build-shop.hook';

export const buildLoader = (queryClient: QueryClient) => {
  return async ({ params: { id } }: LoaderFunctionArgs) => {
    if (isNotDefined(id)) {
      throw new Error('Id parameter is required');
    }

    const query = createBuildShopQuery(id);
    const { queryKey } = query;

    if (!isDefined(queryKey)) {
      throw new Error('QueryKey not provided');
    }

    const token = retrieveToken();

    if (isNotDefined(token) || isTokenExpired(token)) {
      return defer({ shop: undefined });
    }

    const shop = queryClient.ensureQueryData({ ...query, queryKey });

    return defer({ audience: undefined, shop });
  };
};
